export default (params) => ({
  trigger: {
    name: 'alternative_primary_item.select_property',
    params: params,
  },
  config: {
    schema: {
      property_name: {
        type: 'string',
      },
      property_value: {
        type: 'string',
      },
    },
    event: {
      name: 'interact_with_property',
      params: {
        sub_feature: null,
        method: 'explanation',
      },
    },
    nonInt: true,
  },
});
